// Generated from User's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type UserCollectionFilterGroups
  = | {
    readonly id: Iri | Iri[]
  }
  | {
    readonly email: string
  }

export const userCollectionFilterMapping: FilterDefinitionMapping<UserCollectionFilterGroups> = {
  id: 'id',
  email: 'email',
}

export type UserCollectionSort = never

export type UserAdminCollectionFilterGroups
  = | {
    readonly id: Iri | Iri[]
  }
  | {
    readonly email: string
  }

export const userAdminCollectionFilterMapping: FilterDefinitionMapping<UserAdminCollectionFilterGroups> = {
  id: 'id',
  email: 'email',
}

export type UserAdminCollectionSort = 'name' | 'active' | 'email'
